import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=32c8e0fc&lang=css"
import "./App.vue?vue&type=style&index=1&id=32c8e0fc&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/5rs1AT96/0/frontvue/main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c8e0fc"]])

export default __exports__